import { Component, Input } from '@angular/core';
import { ViolationWithMessageItem } from '../validation-group.component';

@Component({
    selector: 'skl-validation-group-hintbox',
    templateUrl: './validation-group-hintbox.component.html',
    styleUrls: ['./validation-group-hintbox.component.scss']
})
export class ValidationGroupHintboxComponent {
    @Input() public validations!: () => ViolationWithMessageItem[];

    public items: ViolationWithMessageItem[] = [];

    public ngOnInit(): void {
        this.items = this.validations();
    }

    public close(): void {
        const event = new CustomEvent('insBackdropTap');
        document.dispatchEvent(event);
    }
}
